<div class="message-container mx-auto container shared-container">
    <vg-button
        [icon]="'back-arrow'"
        [style]="'link'"
        [href]="'purchase/send' | formatUrl | async"
        class="d-none d-md-inline-block"
    >
        {{ 'vg_landing_all_bton-return-label' | translate }}
    </vg-button>
    <vg-button
        [icon]="'back-arrow'"
        [style]="'link'"
        [href]="'purchase/send' | formatUrl | async"
        class="d-md-none"
    ></vg-button>
    <div
        class="row justify-content-center justify-content-md-evenly justify-content-lg-between"
    >
        <div class="col-12 col-md-5 card-size">
            <h1 class="text-h1 text-center text-md-start">
                {{ 'vg_landing_purchase_message_h1_title' | translate }}
            </h1>
            <div class="mb-40 container-card-giftcard-design">
                <vg-card-giftcard-design
                    [price]="purchasePersistence?.amount"
                    [img]="currentImage"
                    [title]="
                        (cardDesign$ | async)?.alternateText!
                            | singleTranslation
                    "
                ></vg-card-giftcard-design>
            </div>
            <vg-swiper-giftcard-design
                (imgChange)="currentImage = $event"
                (selectedCard)="onSelectedCard($event)"
                id="scroll"
            ></vg-swiper-giftcard-design>
        </div>
        <div class="col-12 col-md-7 card-size-2">
            <vg-card-message
                [setCard]="cardDesign$ | async"
                [price]="purchasePersistence?.amount"
                [date]="purchasePersistence?.expiration"
            ></vg-card-message>
        </div>
    </div>
</div>
